import { renderSlot as _renderSlot, resolveDynamicComponent as _resolveDynamicComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _directive_touch = _resolveDirective("touch")!

  return _withDirectives((_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.tag), {
    type: _ctx.type,
    class: _normalizeClass(["p-button-main", [
      `p-button-main--${_ctx.kind}`,
      `-${_ctx.iconColor}`,
      { '-disabled': _ctx.disabled },
      { '-gray-out': _ctx.grayOut }
    ]]),
    disabled: _ctx.disabled,
    style: _normalizeStyle({ width: _ctx.autoWidth ? '100%' : '' }),
    onClick: _ctx.emitClickEvent
  }, {
    default: _withCtx(() => [
      (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.childTag), { class: "p-button-main__icon" }, {
        default: _withCtx(() => [
          _renderSlot(_ctx.$slots, "icon", {}, undefined, true)
        ]),
        _: 3
      })),
      _renderSlot(_ctx.$slots, "default", {}, undefined, true)
    ]),
    _: 3
  }, 8, ["type", "class", "disabled", "style", "onClick"])), [
    [_directive_touch, void 0, "tap"]
  ])
}